<template>
    <div>
        <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-position="top"
            class="auto-form">
            <div class="topic-option">
                    <el-form-item :label="$t('paper.difficultDistribution')+'：'" prop="checkList" style="margin-right: 100px">
                        <el-checkbox-group v-model="ruleForm.checkList" @change="selectLevelChange(1,ruleForm.checkList)">
                            <el-checkbox-button :label="1">{{$t('paper.simple')}}</el-checkbox-button>
                            <el-checkbox-button :label="2">{{$t('paper.medium')}}</el-checkbox-button>
                            <el-checkbox-button :label="3">{{$t('paper.hard')}}</el-checkbox-button>
                        </el-checkbox-group>
                    </el-form-item>

                    <el-form-item :label="$t('paper.topicSource')+'：'" prop="isOnlyMine">
                        <el-select v-model="ruleForm.isOnlyMine" ref="fileTree" placeholder="$t('tip.select')"  @change="selectLevelChange(2,ruleForm.isOnlyMine)">
                            <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
            </div>


            <div class="paper-container">
                <aside class="paper-aside">
                    <el-card class="category">
                        <p>{{$t('paper.single')}}：{{singleNum}} {{$t('paper.dao')}}</p>
                        <p>{{$t('paper.eachTopic')}}：
                            <el-input-number
                                v-model="ruleForm.singleScore" size="mini" :min="1" :max="50"></el-input-number>
                            {{$t('paper.points')}}
                        </p>
                        <p>{{$t('paper.multiple')}}：{{multiNum}} {{$t('paper.dao')}}</p>
                        <p>{{$t('paper.eachTopic')}}：
                            <el-input-number
                                v-model="ruleForm.multiScore" size="mini" :min="1" :max="50"></el-input-number>
                            {{$t('paper.points')}}
                        </p>
                        <p>{{$t('paper.trueOrFalse')}}：{{judgeNum}} {{$t('paper.dao')}}</p>
                        <p>{{$t('paper.eachTopic')}}：
                            <el-input-number
                                v-model="ruleForm.judgeScore" size="mini" :min="1" :max="50"></el-input-number>
                            {{$t('paper.points')}}
                        </p>
                        <p>{{$t('paper.matching')}}：{{matchNum}} {{$t('paper.dao')}}</p>
                        <p>{{$t('paper.eachTopic')}}：
                            <el-input-number
                                v-model="ruleForm.matchScore" size="mini" :min="1" :max="50"></el-input-number>
                            {{$t('paper.points')}}
                        </p>
                    </el-card>
                    <el-card class="total">
                        <p>{{$t('paper.totalQuestions')}}：{{totalQuestions}}</p>
                        <p>{{$t('paper.totalScores')}}：{{paperScore}} {{$t('paper.points')}}</p>
                        <p>{{$t('paper.passScore')}}：{{passScore}} {{$t('paper.points')}}</p>
                    </el-card>
                    <div class="btn-group btn-aside">
                        <el-button type="primary"
                                   class="btn-submit"
                                   @click="submitPaper"
                                  ><i class="nucfont inuc-step-right"></i>
                            {{$t('paper.savePaper')}}
                        </el-button>
                    </div>
                </aside>
                <div class="paper-content">
                    <div class="topic-num-block">
                        <div class="topic-type">
                            <label class="topic-type-name">{{$t('paper.single')}}</label>
                            <el-cascader
                                v-model="ruleForm.singleKnowledge"
                                :options="knowledgeMenu['Theory']"
                                ref="singleCascader"
                                :props="cascadeProp"
                                :placeholder="$t('c.knowledgePoint')"
                                :show-all-levels="false"
                                @change="singleKnowledgeChange"
                                filterable
                                size="small"
                            ></el-cascader>
                        </div>

                        <ul class="topic-kdg-num" v-if="singleKdg.length>0">
                            <li class="item-num" v-for="item in singleKdg" :key="'s'+item.knowledgeID">

                                <p>
                                    {{$t('paper.questionQuantity')}}&ensp;
                                    <el-input-number v-model="item.count" controls-position="right" size="mini" :min="0" :max="item.maxCount"></el-input-number>
                                    &ensp;{{$t('paper.dao')}}
                                </p>
                                <p>
                                    <span class="kp-name">{{item.name}}</span>
                                    ({{$t('paper.questionQuantity')}}&ensp;<span>{{item.maxCount}}</span> {{$t('paper.dao')}})
                                    <span @click="deleteKdg('single',item.knowledgeID)"><i class="nucfont inuc-remove-circle topic-delete"></i></span>
                                </p>

                            </li>
                        </ul>
                        <p class="no-kdg-tip" v-else>{{$t('paper.chooseKpFirst')}}</p>
                    </div>

                    <div class="topic-num-block">
                        <div class="topic-type">
                            <label class="topic-type-name">{{$t('paper.multiple')}}</label>
                            <el-cascader
                                v-model="ruleForm.multiKnowledge"
                                :options="knowledgeMenu['Theory']"
                                ref="multiCascader"
                                :props="cascadeProp"
                                :placeholder="$t('c.knowledgePoint')"
                                :show-all-levels="false"
                                @change="multiKnowledgeChange"
                                filterable
                                size="small"
                            ></el-cascader>
                        </div>

                        <ul class="topic-kdg-num" v-if="multiKdg.length>0">
                            <li class="item-num" v-for="item in multiKdg" :key="'m'+item.knowledgeID">

                                <p>
                                    {{$t('paper.questionQuantity')}}&ensp;
                                    <el-input-number v-model="item.count" controls-position="right" size="mini" :min="0" :max="item.maxCount"></el-input-number>
                                    &ensp;{{$t('paper.dao')}}
                                </p>
                                <p>
                                    <span class="kp-name">{{item.name}}</span>
                                    ({{$t('paper.questionQuantity')}}&ensp;<span>{{item.maxCount}}</span> {{$t('paper.dao')}})
                                    <span @click="deleteKdg('multi',item.knowledgeID)"><i class="nucfont inuc-remove-circle topic-delete"></i></span>
                                </p>

                            </li>
                        </ul>
                        <p class="no-kdg-tip" v-else>{{$t('paper.chooseKpFirst')}}</p>
                    </div>
                    <div class="topic-num-block">
                        <div class="topic-type">
                            <label class="topic-type-name">{{$t('paper.trueOrFalse')}}</label>
                            <el-cascader
                                v-model="ruleForm.judgeKnowledge"
                                :options="knowledgeMenu['Theory']"
                                ref="judgeCascader"
                                :props="cascadeProp"
                                :placeholder="$t('c.knowledgePoint')"
                                :show-all-levels="false"
                                @change="judgeKnowledgeChange"
                                filterable
                                size="small"
                            ></el-cascader>
                        </div>

                        <ul class="topic-kdg-num" v-if="judgeKdg.length>0">
                            <li class="item-num" v-for="item in judgeKdg" :key="'j'+item.knowledgeID">

                                <p>
                                    {{$t('paper.questionQuantity')}}&ensp;
                                    <el-input-number v-model="item.count" controls-position="right" size="mini" :min="0" :max="item.maxCount"></el-input-number>
                                    &ensp;{{$t('paper.dao')}}
                                </p>
                                <p>
                                    <span class="kp-name">{{item.name}}</span>
                                    ({{$t('paper.questionQuantity')}}&ensp;<span>{{item.maxCount}}</span> {{$t('paper.dao')}})

                                </p>
                                <p>
                                    <span @click="deleteKdg('judge',item.knowledgeID)"><i class="nucfont inuc-remove-circle topic-delete"></i></span>
                                </p>
                            </li>
                        </ul>
                        <p class="no-kdg-tip" v-else>{{$t('paper.chooseKpFirst')}}</p>
                    </div>
                    <div class="topic-num-block">
                        <div class="topic-type">
                            <label class="topic-type-name">{{$t('paper.matching')}}</label>
                            <el-cascader
                                v-model="ruleForm.matchKnowledge"
                                :options="knowledgeMenu['Theory']"
                                ref="matchCascader"
                                :props="cascadeProp"
                                :placeholder="$t('c.knowledgePoint')"
                                :show-all-levels="false"
                                @change="matchKnowledgeChange"
                                filterable
                                size="small"
                            ></el-cascader>
                        </div>

                        <ul class="topic-kdg-num" v-if="matchKdg.length>0">
                            <li class="item-num" v-for="item in matchKdg" :key="'j'+item.knowledgeID">
                                <p>
                                    {{$t('paper.questionQuantity')}}&ensp;
                                    <el-input-number v-model="item.count" controls-position="right" size="mini" :min="0" :max="item.maxCount"></el-input-number>
                                    &ensp;{{$t('paper.dao')}}
                                </p>
                                <p>
                                    <span class="kp-name">{{item.name}}</span>
                                    ({{$t('paper.questionQuantity')}}&ensp;<span>{{item.maxCount}}</span> {{$t('paper.dao')}})

                                </p>
                                <p>
                                    <span @click="deleteKdg('match',item.knowledgeID)"><i class="nucfont inuc-remove-circle topic-delete"></i></span>
                                </p>
                            </li>
                        </ul>
                        <p class="no-kdg-tip" v-else>{{$t('paper.chooseKpFirst')}}</p>
                    </div>
                </div>
            </div>

        </el-form>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import api from '@/api';

    export default {
        props: ['passLine', 'paperName','kpName', 'knowledgeName', 'forLevel', 'difficulty'],
        data() {
            return {
                ruleForm: {
                    checkList: [2],
                    singleKnowledge: [],
                    multiKnowledge: [],
                    judgeKnowledge: [],
                    matchKnowledge: [],
                    singleNum: 0,
                    multiNum: 0,
                    judgeNum: 0,
                    matchNum: 0,
                    singleScore: 1,
                    multiScore: 1,
                    judgeScore: 1,
                    matchScore: 1,
                    singleTotal: 0,
                    multiTotal: 0,
                    judgeTotal: 0,
                    matchTotal: 0,
                    totalScore: 0,
                    passScore: 0,
                    isOnlyMine:true
                },
                options: [{
                    value: false,
                    label: this.$t('topic.examPaperLibrary')
                }, {
                    value: true,
                    label: this.$t('topic.myTopic')
                }],
                singleKdg: [],
                multiKdg: [],
                judgeKdg: [],
                matchKdg: [],
                singleToNum: 0,
                multiToNum: 0,
                judgeToNum: 0,
                matchToNum: 0,
                rules: {
//                    checkList: {required: true, message: this.$t('tip.difficulty'), trigger: 'change'},
//                    isOnlyMine: {required: true, message: this.$t('tip.chooseTopicSource'), trigger: 'change'}
                },
                cascadeProp: {
                    value: 'id',
                    label: 'value',
                    children: 'children'
                },
            }
        },
        created() {
             this.ruleForm.singleKnowledge=this.knowledgeName
             this.ruleForm.multiKnowledge=this.knowledgeName
             this.ruleForm.judgeKnowledge=this.knowledgeName
             this.ruleForm.matchKnowledge=this.knowledgeName
             let kpID=this.knowledgeName[this.knowledgeName.length-1]
             let singleSubmitData = {
                    difficulties: this.ruleForm.checkList,
                    topicType: 'Single',
                    knowledge: kpID,
                    isOnlyMine: this.ruleForm.isOnlyMine,
                };
                api.getTopicStock(singleSubmitData).then(res => {
                    this.singleKdg.push({name:this.kpName,maxCount:res.package,count:0,knowledgeID:kpID})
                });
                let multiSubmitData = {
                    difficulties: this.ruleForm.checkList,
                    topicType: 'Multiple',
                    knowledge: kpID,
                    isOnlyMine: this.ruleForm.isOnlyMine,
                };
                api.getTopicStock(multiSubmitData).then(res => {
                    this.multiKdg.push({name:this.kpName,maxCount:res.package,count:0,knowledgeID:kpID})
                 });
                let judgeSubmitData = {
                    difficulties: this.ruleForm.checkList,
                    topicType: 'TrueOrFalse',
                    knowledge: kpID,
                    isOnlyMine: this.ruleForm.isOnlyMine,
                };
                api.getTopicStock(judgeSubmitData).then(res => {
                    this.judgeKdg.push({name:this.kpName,maxCount:res.package,count:0,knowledgeID:kpID})
                });
                let matchSubmitData = {
                    difficulties: this.ruleForm.checkList,
                    topicType: 'PicturePair',
                    knowledge: kpID,
                    isOnlyMine: this.ruleForm.isOnlyMine,
                };
                api.getTopicStock(matchSubmitData).then(res => {
                    this.matchKdg.push({name:this.kpName,maxCount:res.package,count:0,knowledgeID:kpID})
                });
        },
        computed: {
            ...mapGetters([
                'knowledgeMenu',
            ]),
            totalQuestions() {
                return (this.singleNum||0) + (this.multiNum||0) + (this.judgeNum||0) + (this.matchNum||0);
            },
            paperScore() {
                return (this.singleNum||0) * this.ruleForm.singleScore +
                       (this.multiNum||0) * this.ruleForm.multiScore +
                       (this.judgeNum||0) * this.ruleForm.judgeScore +
                       (this.matchNum||0) * this.ruleForm.matchScore;
            },
            passScore() {
                return (this.paperScore*this.passLine).toFixed(1);
            },
            singleNum(){
                let total=0
                this.singleKdg.forEach(item=>{
                    total += item.count ||0;
                })
                return total;
            },
            multiNum(){
                let total=0
                this.multiKdg.forEach(item=>{
                    total += item.count ||0;
                })
                return total;
            },
            judgeNum(){
                let total=0
                this.judgeKdg.forEach(item=>{
                    total += item.count ||0;
                })
                return total;
            },
            matchNum(){
                let total=0
                this.matchKdg.forEach(item=>{
                    total += item.count ||0;
                })
                return total;
            },
        },
        methods: {
            //考题难易分布  考题来源
            selectLevelChange(type,value) {
                if(this.singleKdg.length>0){
                    this.singleKdg.forEach(item=>{
                        let singleSubmitData = {
                            difficulties: type==1?value:this.ruleForm.checkList,
                            topicType: 'Single',
                            knowledge: item.knowledgeID,
                            isOnlyMine: type==2?value:this.ruleForm.isOnlyMine,
                        };
                        api.getTopicStock(singleSubmitData).then(res => {
                            let max=res.package;
                            item.maxCount=max;
                            if(item.count>max){
                                item.count=max;
                            }
                        });
                    })
                }
                if(this.multiKdg.length>0){
                    this.multiKdg.forEach(item=>{
                        let multiSubmitData = {
                            difficulties: type==1?value:this.ruleForm.checkList,
                            topicType: 'Multiple',
                            knowledge: item.knowledgeID,
                            isOnlyMine: type==2?value:this.ruleForm.isOnlyMine,
                        };
                        api.getTopicStock(multiSubmitData).then(res => {
                            let max=res.package;
                            item.maxCount=max;
                            if(item.count>max){
                                item.count=max
                            }
                        });

                    })
                }
                if(this.judgeKdg.length>0){
                    this.judgeKdg.forEach(item=>{
                        let judgeSubmitData = {
                            difficulties: type==1?value:this.ruleForm.checkList,
                            topicType: 'TrueOrFalse',
                            knowledge: item.knowledgeID,
                            isOnlyMine: type==2?value:this.ruleForm.isOnlyMine,
                        };
                        api.getTopicStock(judgeSubmitData).then(res => {
                            let max=res.package;
                            item.maxCount=max;
                            if(item.count>max){
                                item.count=max
                            }
                        });

                    })
                }
                if(this.matchKdg.length>0){
                    this.matchKdg.forEach(item=>{
                        let matchSubmitData = {
                            difficulties: type==1?value:this.ruleForm.checkList,
                            topicType: 'PicturePair',
                            knowledge: item.knowledgeID,
                            isOnlyMine: type==2?value:this.ruleForm.isOnlyMine,
                        };
                        api.getTopicStock(matchSubmitData).then(res => {
                            let max=res.package;
                            item.maxCount=max;
                            if(item.count>max){
                                item.count=max
                            }
                        });

                    })
                }
            },

            //知识点变化
            singleKnowledgeChange(data){
                let id=data[data.length-1]
                let index = this.singleKdg.findIndex(v=>v.knowledgeID==id)
                if(index == -1){
                    let currentLabel = ''
                    setTimeout(()=>{
                        currentLabel =this.$refs.singleCascader.presentText
                    },0)
                    this.ruleForm.singleKnowledge = data;
                    let singleSubmitData = {
                        difficulties: this.ruleForm.checkList,
                        topicType: 'Single',
                        knowledge: id,
                        isOnlyMine: this.ruleForm.isOnlyMine,
                    };
                    api.getTopicStock(singleSubmitData).then(res => {
                        this.singleKdg.push({name:currentLabel,maxCount:res.package,count:0,knowledgeID:id})
                    });
                }
            },
            multiKnowledgeChange(data){
                let id=data[data.length-1]
                let index = this.multiKdg.findIndex(v=>v.knowledgeID==id)
                if(index == -1){
                    let currentLabel = ''
                    setTimeout(()=>{
                        currentLabel =this.$refs.multiCascader.presentText
                    },0)
                    this.ruleForm.multiKnowledge = data;
                    let multiSubmitData = {
                        difficulties: this.ruleForm.checkList,
                        topicType: 'Multiple',
                        knowledge: id,
                        isOnlyMine: this.ruleForm.isOnlyMine,
                    };
                    api.getTopicStock(multiSubmitData).then(res => {
                        this.multiKdg.push({name:currentLabel,maxCount:res.package,count:0,knowledgeID:id})
                    });
                }
            },
            judgeKnowledgeChange(data){
                let id=data[data.length-1]
                let index = this.judgeKdg.findIndex(v=>v.knowledgeID==id)
                if(index == -1){
                    let currentLabel = ''
                    setTimeout(()=>{
                        currentLabel = this.$refs.judgeCascader.presentText
                    },0)
                    this.ruleForm.judgeKnowledge = data;
                    let judgeSubmitData = {
                        difficulties: this.ruleForm.checkList,
                        topicType: 'TrueOrFalse',
                        knowledge: id,
                        isOnlyMine: this.ruleForm.isOnlyMine,
                    };
                    api.getTopicStock(judgeSubmitData).then(res => {
                        this.judgeKdg.push({name:currentLabel,maxCount:res.package,count:0,knowledgeID:id})
                    });
                }
            },
            matchKnowledgeChange(data){
                let id=data[data.length-1]
                let index = this.matchKdg.findIndex(v=>v.knowledgeID==id)
                if(index == -1){
                    let currentLabel = ''
                    setTimeout(()=>{
                        currentLabel = this.$refs.matchCascader.presentText
                    },0)
                    this.ruleForm.matchKnowledge = data;
                    let matchSubmitData = {
                        difficulties: this.ruleForm.checkList,
                        topicType: 'PicturePair',
                        knowledge: id,
                        isOnlyMine: this.ruleForm.isOnlyMine,
                    };
                    api.getTopicStock(matchSubmitData).then(res => {
                        this.matchKdg.push({name:currentLabel,maxCount:res.package,count:0,knowledgeID:id})
                    });
                }
            },
            deleteKdg(type,id){
              switch (type){
                  case 'single':
                      let sidx=this.singleKdg.findIndex(v=>v.knowledgeID==id)
                      this.singleKdg.splice(sidx,1)
                      return
                  case 'multi':
                      let midx=this.multiKdg.findIndex(v=>v.knowledgeID==id)
                      this.multiKdg.splice(midx,1)
                      return
                  case 'judge':
                      let jidx=this.judgeKdg.findIndex(v=>v.knowledgeID==id)
                      this.judgeKdg.splice(jidx,1)
                      return
                  case 'match':
                      let maidx=this.matchKdg.findIndex(v=>v.knowledgeID==id)
                      this.matchKdg.splice(maidx,1)
                      return
              }
            },
            lastStep() {
                this.$emit('last-step');
            },
            submitPaper() {
                if (!this.singleNum && !this.multiNum && !this.judgeNum && !this.matchNum) {
                    this.$message(this.$t('paper.paperNumGtOne'));
                    return;
                }
                let itemList = [];
                this.singleKdg.forEach(item=>{
                    itemList.push({type:1,score:this.ruleForm.singleScore,count:item.count,knowledgeID:item.knowledgeID})
                })
                this.multiKdg.forEach(item=>{
                    itemList.push({type:2,score:this.ruleForm.multiScore,count:item.count,knowledgeID:item.knowledgeID})
                })
                this.judgeKdg.forEach(item=>{
                    itemList.push({type:3,score:this.ruleForm.judgeScore,count:item.count,knowledgeID:item.knowledgeID})
                })
                this.matchKdg.forEach(item=>{
                    itemList.push({type:4,score:this.ruleForm.matchScore,count:item.count,knowledgeID:item.knowledgeID})
                })
                let submitData = {
                    topicDifficulties: this.ruleForm.checkList,
                    items: itemList,
                    difficulty: this.difficulty,
                    title: this.paperName,
                    forLevel: this.forLevel,
                    knowledge: this.knowledgeName[this.knowledgeName.length - 1],
                    passLine: this.passLine,
                    isOnlyMine: this.ruleForm.isOnlyMine,
                };

                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        api.theoryPaperAutomatic(submitData).then(res => {
                            this.$notify({
                                title: res.error,
                                message: this.$t('paper.smartGroupSuccess')+'!',
                                type: 'success',
                                duration: 2000
                            });

                            this.$emit('needUpdate');
                            this.$router.replace({name: 'myPaper'})
                        });
                        // console.log(submitData);
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
                });

            },

        },
        watch: {},
        components: {}
    }
</script>

<style scoped lang="scss">
    @import '../../../style/const';
    .auto-form {
        color: #252525;
        .topic-num-block{
            margin-bottom: 35px;
        }
        .topic-type {
            margin-bottom: 15px;
            .topic-type-name{
                padding: 6px 20px;
                color: #fff;
                background-color: #2e7faa;
            }

            p {
                display: inline-block;
                margin-left: 4.3%;
            }

            .el-cascader {
                margin-left: 4.3%;
            }
        }
        .topic-kdg-num{
            .item-num{
                display: flex;
                margin-bottom: 15px;
                line-height: 26px;
                .kp-name{
                    display: inline-block;
                    border: 1px solid #22bdff;
                    color: #22bdff;
                    padding: 0px 8px;
                    margin-right: 5px;
                    margin-left: 20px;
                }
                .topic-delete{
                    display: inline-block;
                    color: #afafaf;
                    cursor: pointer;
                    margin-left: 20px;

                }
            }
        }
        .count {
            > p {
                display: inline-block;
                margin-right: 84px;
            }
        }
    }
    .topic-option{
        display: flex;
        margin-bottom: 37px;
    }
    .paper-container {
        @include clearfix();
    }
    .paper-content{
        margin-right: 500px;
    }

    .paper-aside {
        float: right;
        width: 260px;
        margin-right: 250px;

        &.affixed {
            position: fixed;
            top: $h-nav + 80;
            right: 70px;
            z-index: 1;
        }

        .category {
            p {
                margin-bottom: 12px;
            }

            .el-input-number {
                width: 100px;
                margin: 0 6px;
            }
        }

        .total {
            margin-top: 15px;

            p {
                margin-bottom: 8px;
            }
        }

        .btn-aside {
            margin-top: 10px;

            button {
                width: 160px;
                margin-top: 15px;
                margin-left: 0;
            }

            .btn-submit {
                font-size: 16px;
                letter-spacing: 1px;
                color: #ffffff;
            }
        }
    }

    @media screen and (max-width: 1280px) {
        .paper-aside, .paper-content {
            margin-right: 0;
        }
    }

    .app-root:not(.lang-zh-CN) {
        .paper-aside {
            width: auto;
            margin-right: 130px;
        }
        .paper-content {
            margin-right: 0;
        }
        .btn-submit {
            width: auto;
        }
    }
</style>
